import type { IntegrationName } from "@tellescope/tanstack-query";
import { HealthieTemplatesStep } from "./integrations/healthie/HealthieTemplatesStep";
import { TwilioSetupStepAdapter } from "./integrations/twilio/TwilioSetupStepAdapter";
import type { IntegrationStepDefinition } from "./types";
import { HealthiePatientImportStep } from "../components/SetupDialog/plan-dialogs/steps";

/**
 * The ordered setup steps per integration. The dialog flow walks these in
 * {@link getPlanIntegrationConfigs} order; each step's outcome is persisted under
 * its `${integration}:${key}` status key once resolved. Add an integration's
 * steps here when extending {@link IntegrationName}.
 */
export const INTEGRATION_SETUP_STEPS: Record<IntegrationName, readonly IntegrationStepDefinition[]> = {
  healthie: [
    { key: "templates", Component: HealthieTemplatesStep },
    { key: "patients", Component: HealthiePatientImportStep, required: true },
  ],
  twilio: [{ key: "setup", Component: TwilioSetupStepAdapter }],
};
